import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BvErrorData } from '../components/bv-error/bv-error.types';

export interface BvErrorState {
  showModal: boolean;
  data: BvErrorData | null;
  isMobile: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class BvErrorUIStore {
  private bvErrorStateSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
  private insuranceSubmissionResultSubject: BehaviorSubject<any> = new BehaviorSubject(null);
  private currentPolicyNumberSubject: BehaviorSubject<string | null> = new BehaviorSubject(null);

  get showBvErrorModal$(): Observable<boolean> {
    return this.bvErrorStateSubject.asObservable().pipe(
      map((state) => state)
    );
  }

  showBvErrorModal(show: boolean): void {
    this.bvErrorStateSubject.next(show);
  }

  hideBvErrorModal(hide: boolean): void {
    this.bvErrorStateSubject.next(hide);
  }

  setInsuranceSubmissionResult(result: { insuranceUpdated: boolean; bvError: boolean; chcHasAnOutage: boolean; insuranceAddedId: number; }): void {
    this.insuranceSubmissionResultSubject.next(result);
  }

  getInsuranceSubmissionResult(): Observable<any> {
    return this.insuranceSubmissionResultSubject.asObservable();
  }

  clearInsuranceSubmissionResult(): void {
    this.insuranceSubmissionResultSubject.next(null);
  }

  setPolicyNumber(policyNumber: string | null): void {
    this.currentPolicyNumberSubject.next(policyNumber);
  }

  getPolicyNumber(): string | null {
    return this.currentPolicyNumberSubject.getValue();
  }

  clearPolicyNumber(): void {
    this.currentPolicyNumberSubject.next(null);
  }
}
